import React, { useEffect, useState } from "react";
import { RotateCcw, Trash2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DAY = 86400000;
const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso).getTime() + 30 * DAY - Date.now()) / DAY));

export const AdminTrash = ({ token, onRestored }) => {
  const [items, setItems] = useState(null);
  const h = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  const load = () => fetch(`${API}/admin/trash`, { headers: h }).then((r) => r.json()).then((d) => setItems(Array.isArray(d) ? d : []));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const act = async (path, ids) => {
    const r = await fetch(`${API}/admin/trash/${path}`, { method: "POST", headers: h, body: JSON.stringify({ ids }) });
    if (!r.ok) return window.alert("Something went wrong. Please try again.");
    setItems((p) => p.filter((x) => !ids.includes(x.id)));
    if (path === "restore") onRestored();
  };
  const purge = (t) => window.confirm(`Delete ${t.name || "this entry"} forever? This cannot be undone.`) && act("purge", [t.id]);

  if (!items) return <p className="text-slate-500">Loading trash...</p>;
  return (
    <div data-testid="admin-trash">
      <p className="text-sm text-slate-600 mb-4">Deleted leads and quotes stay here for 30 days, then clear out on their own. Restore puts an entry back exactly as it was.</p>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        {items.length === 0 ? <p className="p-8 text-center text-slate-500" data-testid="trash-empty">Trash is empty.</p> : (
          <table className="w-full text-sm">
            <thead className="bg-slate-100 text-left text-slate-600"><tr><th className="px-4 py-3">From</th><th className="px-4 py-3">Name</th><th className="px-4 py-3">Contact</th><th className="px-4 py-3">Details</th><th className="px-4 py-3">Clears in</th><th className="px-4 py-3"></th></tr></thead>
            <tbody>
              {items.map((t) => (
                <tr key={t.id} className="border-t border-slate-100 align-top" data-testid={`trash-row-${t.id}`}>
                  <td className="px-4 py-3"><span className="px-2 py-1 rounded-full text-xs font-semibold bg-slate-100 text-slate-600">{t.kind === "leads" ? "Lead" : "Quote"}</span></td>
                  <td className="px-4 py-3 font-medium text-[#0a1f44]">{t.name || "No name"}<div className="text-xs text-slate-400 font-normal">{t.created_at ? new Date(t.created_at).toLocaleDateString() : ""}</div></td>
                  <td className="px-4 py-3 text-slate-600">{t.email}<br />{t.phone}</td>
                  <td className="px-4 py-3 text-slate-600 max-w-sm">{t.service && <div className="text-xs text-slate-400">Service: {t.service}</div>}<span className="line-clamp-2">{t.message}</span></td>
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap" data-testid={`trash-days-${t.id}`}>{daysLeft(t.deleted_at)} days</td>
                  <td className="px-4 py-3 text-right whitespace-nowrap">
                    <button onClick={() => act("restore", [t.id])} data-testid={`trash-restore-${t.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-[#3b9dff] hover:bg-[#2b8ae8] text-white text-xs font-semibold mr-2"><RotateCcw className="w-3.5 h-3.5" /> Restore</button>
                    <button onClick={() => purge(t)} data-testid={`trash-purge-${t.id}`} title="Delete forever" className="text-slate-400 hover:text-red-500"><Trash2 className="w-4 h-4 inline" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
